import Modal from "react-bootstrap/Modal";
import { Card, CardBody, Col, ModalBody, Placeholder, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLazyGetRestaurantsByOwnerIdQuery } from "../../redux/services/restaurantServices";
import { useDispatch } from "react-redux";
import {
  openInitialSlectReastaurantModla,
  setSelectedRestaurantDetails,
} from "../../redux/restaurantsSlice";
import ButtonComponent from "../ButtonComponent";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPointDown } from "@fortawesome/free-solid-svg-icons";
import { truncateText } from "../../utility/Utility";
import "./index.css";

export interface Restaurant {
  ownerId: string;
  id?: string;
  address: string;
  displayName: string;
  averageDeliveryTime: string;
  imageUrl: string;
  location: { latitude: number; longitude: number };
  rating: number;
  distance: number;
  hasOffers: boolean;
  status?: string;
  isMember: boolean;
  createdDate?: string;
  categoryTags: string[];
  openingTime?: string;
  closingTime?: string;
  type: any;
  restaurantProperties?: string[];
  supportsDirectOrders?: boolean;
  canCollectMoney?: boolean;
  flowTypes?: string[];
  acceptCartReturns?: boolean;
   deliverySettings: {
    isFreeDelivery: boolean;
    perItemDeliveryFee: number;
  };
  deliveryTimeSlots?: string[];
}

const ReastaurantSlectModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ownerId = localStorage.getItem("ownerID");

  const [modalShow, setModalShow] = useState(true);
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isRestaurantSelected, setIsRestaurantSelected] = useState(false);


  const [trigger, { data: resturantData, isLoading }] =
    useLazyGetRestaurantsByOwnerIdQuery();

  const handleRowClick = (restaurant: Restaurant) => {
    if (restaurant.status === "Pending" || restaurant.status === "Rejected") {
      return;
    }
    localStorage.setItem("selectedRestaurantId", restaurant.id || "");
    dispatch(openInitialSlectReastaurantModla(true));
    dispatch(setSelectedRestaurantDetails(restaurant));
    setIsRestaurantSelected(true);
    setModalShow(false);
    toast.success("You have successfully logged in to a restaurant.");
  };

  const handleCreateRestaurantBtn = () => {
    navigate("/profile/add-restaurant");
  };

  useEffect(() => {
    if (ownerId) {
      trigger(ownerId);
    }
  }, [ownerId, trigger]);

  return (
    <div style={{ position: "relative" }}>
      <Modal
        show={modalShow}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-align-center"
          >
            <h4 className="restaurant-select-modal-title">Select Your Restaurant From the Following List</h4>
          </Modal.Title>
        </Modal.Header>
        <ModalBody>
          <Card>
            <CardBody>
              {isLoading ? (
                <>
                  <Row className="g-4">
                    {[...Array(6)].map((_, index) => (
                      <Col key={index} md={4}>
                        <Card className="load-msg-card">
                          <Placeholder as={Card.Img} animation="wave" style={{ backgroundColor: "#ddd", border: "none", height: "200px" }} />
                          <Card.Body >
                            <Placeholder as={Card.Title} animation="wave">
                              <Placeholder xs={6} />
                            </Placeholder>
                            <Placeholder as={Card.Text} animation="wave">
                              <Placeholder xs={8} />
                              <Placeholder xs={4} />
                            </Placeholder>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row></>
              ) : resturantData &&
                resturantData.restaurantList.restaurants.length > 0 ? (
                <div className="restaurant-grid">
                  {resturantData?.restaurantList?.restaurants.map(
                    (restaurant: Restaurant, index: number) => (
                      <div
                        key={restaurant?.id}
                        onClick={() => handleRowClick(restaurant)}
                        className={`restaurant-card ${restaurant.status === "Pending" || restaurant.status === "Rejected"
                          ? "not-clickable"
                          : ""
                          }`}
                      >
                        <img
                          src={restaurant?.imageUrl}
                          alt="Restaurant "
                          className="restaurant-image"
                        />
                        <div className="restaurant-info">
                          <h5>{truncateText(restaurant.displayName, 20)}</h5>
                          <p>{truncateText(restaurant.address, 30)}</p>
                          <p><b>Rating : </b>{restaurant.rating.toFixed(2)}</p>
                          {restaurant.status === "Pending" && (
                            <p className="restaurant-status">Pending</p>
                          )}
                          {restaurant.status === "Rejected" && (
                            <p className="restaurant-status">Rejected</p>
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div>
                  <p className="no-restaurants-message">
                    You haven't got any restaurants. Click the following button
                    to create a restaurant.
                  </p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flexGrow: 1 }}></div>
                    <FontAwesomeIcon
                      icon={faHandPointDown}
                      className="up-down-animation"
                    />
                  </div>
                </div>
              )}
            </CardBody>
          </Card>
        </ModalBody>
        <Modal.Footer>
          <ButtonComponent
            titel={"Create Restaurant"}
            onClick={handleCreateRestaurantBtn}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReastaurantSlectModal;

